import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { softwareDevelopmentData } from '../data/softwareDevelopmentData';

const ServicesPage = () => {
  return (
    <div className="bg-gray-50">
      <Header />
      <div className="container mx-auto px-6 pt-40 pb-20">
        <Fade direction="down" duration={1000}>
          <h1 className="text-5xl font-bold text-center text-gray-800">Our Development Services</h1>
          <p className="text-center text-gray-600 mt-4 max-w-2xl mx-auto">We provide a wide range of development services to help you achieve your business goals. Explore our services to see how we can help you build the future of your business.</p>
        </Fade>

        <div className="mt-20 space-y-20">
          {softwareDevelopmentData.map((service, index) => (
            <Fade key={index} direction={index % 2 === 0 ? 'left' : 'right'} duration={1000}>
              <div className={`flex flex-col md:flex-row items-center gap-10 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}>
                <div className="w-full md:w-1/2 h-80">
                  <img src={service.image} alt={service.title} className="rounded-lg shadow-lg object-cover w-full h-full" />
                </div>
                <div className="w-full md:w-1/2">
                  <h2 className="text-3xl font-bold text-gray-800">{service.title}</h2>
                  <p className="text-gray-600 mt-4">{service.description}</p>
                  <Link to={`/services/${service.id}`}>
                    <button className="mt-6 group relative overflow-hidden bg-transparent text-[#4a9bc4] font-medium px-6 py-2 text-sm rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-105 hover:shadow-md hover:bg-gradient-to-br from-[#58afd1] to-[#4a9bc4] hover:text-white border-2 border-[#58afd1]">
                      Learn More
                      <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                    </button>
                  </Link>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
